import { wclFetch } from "../helpers";

document.addEventListener('DOMContentLoaded', () => {
   const postsFilter = document.querySelector('.wcl-posts-grid-block');

   if (!postsFilter) {
      return;
   }

   const tabs = postsFilter.querySelectorAll('.wcl-posts-filter__tab');
   const postsContainer = postsFilter.querySelector('.wcl-posts-grid-block__posts');
   const paginationContainer = postsFilter.querySelector('.wcl-posts-pagination');
   const loader = postsFilter.querySelector('.wcl-loader');

   const disablePagination = postsFilter.dataset.disablePagination;

   const applyAdditionalFilters = postsFilter.dataset.applyAdditionalFilters === '1';

   const videosBlock = document.querySelector('.wcl-videos-block');

   let loading = false;


   const filterVideos = (termId) => {
      if (!applyAdditionalFilters || !videosBlock) {
         return;
      }

      const videos = videosBlock.querySelectorAll('.wcl-videos-block__item');

      videos.forEach((video) => {
         const categories = video.dataset.categoryIds
            ? video.dataset.categoryIds.split(',')
            : [];

         const showVideo = termId === '0'
            ? categories.some((category) => filterTerms.includes(category))
            : categories.includes(termId);

         video.style.display = showVideo ? '' : 'none';
      });
   };


   /*
    * Get selected tags from tabs, excluding "All".
   */

   const filterTerms = Array.from(tabs)
      .map((tab) => tab.dataset.termId)
      .filter((termId) => termId && termId !== '0');


   tabs.forEach((tab) => {

      tab.addEventListener('click', async () => {

         if (loading || tab.classList.contains('is-active')) {
            return;
         }

         const termId = tab.dataset.termId;
         const postsCount = postsContainer.dataset.postsCount;

         loading = true;

         tabs.forEach((item) => {
            item.disabled = true;
         });

         postsFilter.classList.add('is-loading');
         loader.classList.add('is-active');

         const data = new FormData();

         data.set('action', 'filter_posts');
         data.set('term_id', termId);
         data.set('posts_count', postsCount);
         data.set('post_id', config.post_id);
         data.set('disable_pagination', disablePagination);

         /*
          * Send selected tags for "All".
          */

         filterTerms.forEach((filterTerm) => {
            data.append('filter[]', filterTerm);
         });

         try {

            const response = await wclFetch(
               data,
               'POST',
               false
            );

            if (!response.ok) {
               throw new Error('Failed to load posts');
            }

            const result = await response.json();

            if (!result.success) {
               throw new Error(
                  result.data?.message || 'Failed to load posts'
               );
            }


            /*
            * Update posts.
            */
            postsContainer.innerHTML = result.data.post_markup;

            const emptyMessage = postsFilter.querySelector('.wcl-posts-grid-block__empty');

            if (emptyMessage) {
               emptyMessage.remove();
            }

            if (result.data.empty_markup) {
               postsContainer.insertAdjacentHTML(
                  'afterend',
                  result.data.empty_markup
               );
            }

            /*
            * Update active tab.
            */
            tabs.forEach((item) => {
               item.classList.remove('is-active');
            });

            tab.classList.add('is-active');


            /*
             * Update videos.
             */
            filterVideos(termId);


            /*
            * Update pagination.
            *
            * If the selected tab has fewer posts
            * than posts_count, this will be empty.
            */
            if (paginationContainer) {
               paginationContainer.innerHTML = result.data.pagination_markup;
            }

         } catch (error) {
            console.error(error);
         } finally {
            loading = false;

            tabs.forEach((item) => {
               item.disabled = false;
            });

            postsFilter.classList.remove('is-loading');
            loader.classList.remove('is-active');
         }
      });
   });
});